import LoadingDots from './LoadingDots';

export default LoadingDots;
